"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuehrungsrinnenConfigError = exports.FuehrungsrinnenConfigErrorType = void 0;
/**
 * Error type that represents an error that can occur during the creation of Fuehrungsrinnen configurations.
 */
var FuehrungsrinnenConfigErrorType;
(function (FuehrungsrinnenConfigErrorType) {
    // Führungsrinne ohne Gleitschiene
    FuehrungsrinnenConfigErrorType["Fuehrungsrinne"] = "Fuehrungsrinne";
    FuehrungsrinnenConfigErrorType["FuehrungsrinneStuecklaenge"] = "FuehrungsrinneStuecklaenge";
    FuehrungsrinnenConfigErrorType["FuehrungsrinneLaenge"] = "FuehrungsrinneLaenge";
    FuehrungsrinnenConfigErrorType["FuehrungsrinneAnzahl"] = "FuehrungsrinneAnzahl";
    // Führungsrinne mit Gleitschiene
    FuehrungsrinnenConfigErrorType["FuehrungsrinneGleitschiene"] = "FuehrungsrinneGleitschiene";
    FuehrungsrinnenConfigErrorType["FuehrungsrinneGleitschieneStuecklaenge"] = "FuehrungsrinneGleitschieneStuecklaenge";
    FuehrungsrinnenConfigErrorType["FuehrungsrinneGleitschieneLaenge"] = "FuehrungsrinneGleitschieneLaenge";
    FuehrungsrinnenConfigErrorType["FuehrungsrinneGleitschieneAnzahl"] = "FuehrungsrinneGleitschieneAnzahl";
    // Führungsrinne mit Festpunktmodul
    FuehrungsrinnenConfigErrorType["FuehrungsrinneFestpunktmodul"] = "FuehrungsrinneFestpunktmodul";
    FuehrungsrinnenConfigErrorType["FuehrungsrinneFestpunktmodulStuecklaenge"] = "FuehrungsrinneFestpunktmodulStuecklaenge";
    // Fuehrungsrinne Allgemein
    FuehrungsrinnenConfigErrorType["FuehrungsrinneGesamtLaenge"] = "FuehrungsrinneGesamtLaenge";
    // Montage Set
    FuehrungsrinnenConfigErrorType["MontageSet"] = "MontageSet";
    FuehrungsrinnenConfigErrorType["MontageSetAnzahl"] = "MontageSetAnzahl";
})(FuehrungsrinnenConfigErrorType = exports.FuehrungsrinnenConfigErrorType || (exports.FuehrungsrinnenConfigErrorType = {}));
/**
 * A Fuehrungsrinnen configuration error that can occur during the creation of Fuehrungsrinnen.
 */
class FuehrungsrinnenConfigError {
    constructor(type) {
        this._type = type;
    }
    get type() {
        return this._type;
    }
}
exports.FuehrungsrinnenConfigError = FuehrungsrinnenConfigError;
//# sourceMappingURL=FuehrungsrinneConfigError.js.map